import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  changeSuccessMsg: null,
  changeError: null,
};

const changePasswordSlice = createSlice({
  name: "changepwd",
  initialState,
  reducers: {
      userChangePasswordSuccess(state, action) {
          state.changeSuccessMsg = action.payload;
          state.changeError = null;
      },
      userChangePasswordError(state, action) {
          state.changeError = action.payload;
          state.changeSuccessMsg = null;
      },
  },
});

export const {
  userChangePasswordSuccess,
  userChangePasswordError
} = changePasswordSlice.actions;

export default changePasswordSlice.reducer;
